import router from "./router";
import store from "./store";
import NProgress from "nprogress"; // Progress 进度条
import "nprogress/nprogress.css"; // Progress 进度条样式
import { getToken, removeStorage, getHeadCode } from "@/utils/auth"; // 验权
const whiteList = ["/login", "/initPwd", "/wxlogin", "/register", "/resetPwd", "/updateAuthUser","/updateAuthUserLLSHR"]; // 不重定向白名单
import { Message, MessageBox, Notification } from "element-ui";

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  if (store.getters.token) {
    // console.log("111111111")
    if (store.getters.permission_routes.length <= 0) {
      // console.log("22222222")
      store.dispatch('user/getInfo').then(res => {
        store.dispatch("permission/generateRoutes", res.authFuncs).then(accessRoutes => {
          router.addRoutes(accessRoutes);
          // next({...to, replace: true});
          if (to.path === "/login" || to.path === "/" || to.path === ''|| to.path === 'updateAuthUser') {
            // console.log("444444")
            next({ path: accessRoutes[0].redirect })
          } else {
            // console.log("55555555")
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
          }
        })
      }).catch(err => {

      })
    } else {
      if (to.path === "/login" || to.path === "/" || to.path === '') {
        next({ path: store.getters.permission_routes[0].redirect });
        NProgress.done();
      } else {
        next();
      }
    }
  } else {
    // console.log("333333")
    let url = window.location.href
    let list = url.split("?");
    let token = undefined;
    let refreshToken = undefined;
    let self = false;
    let thirdsso = undefined;
    let loginSource = undefined;

    if (list.length > 1) {
      let arrsplid2 = list[1].split('&')
      for (let i = 0; i < arrsplid2.length; i++) {
        // 在数组里面再次根据 = 分割
        let data = arrsplid2[i].split('=')
        data[0] == 'token' ? token = data[1] : data[0] == 'refreshToken' ? refreshToken = data[1] : data[0] == 'self' ? self = data[1] :
        data[0] == 'thirdsso' ? thirdsso = data[1] : data[0] == 'loginSource' ? loginSource = data[1] : undefined
      }

   
  
      if (token && refreshToken) {
        //执行token初次登录
        store.dispatch('user/token_utl', { 'token': token, 'refreshToken': refreshToken, 'self': self }).then(response => {
          // console.log("token_utl", response)
          store.dispatch('user/tokenLogin').then(res => {
            // console.log("tokenRes3333", res)
            // console.log("res", res)
            next({ path: '/' })
          }).catch(err => {
          }).catch(() => {
          })
        })

      } else if (whiteList.indexOf(to.path) !== -1) {
        next();
      } else {
  

        //处理万豪等第三方发接入
        if(thirdsso != undefined && (thirdsso == "marriott" || thirdsso == "marriottTest01")){
            next({ path: '/updateAuthUser' })
        }else if(thirdsso != undefined && (thirdsso == "LLSHR_Pay" || thirdsso == "LLSHR_PayTEST")){
          next({ path: '/updateAuthUserLLSHR' })
        }
        else if(loginSource != undefined && loginSource != null && loginSource != ""){
            //处理loginSource 登录来源
            //存入loginSource
           store.dispatch('user/storeLoginSource', loginSource).then(response => {
                // console.log("存入loginSource成功")
                next({ path: '/login'})
                NProgress.done();
            })
        }
        else {
          MessageBox.confirm('当前会话已过期,请重新登录', {
            confirmButtonText: '重新登录',
            type: 'warning',
            closeOnClickModal: false,
            showCancelButton: false,
            showClose: false,
          }).then(() => {
            store.dispatch('user/logOut').then(() => {
              // next({ path: '/login' });
            })
          }).catch(() => {
          });
        }
      }
    } else {
      // console.log("to.111122", to.path)
      // 在免登录白名单，直接进入
      if (whiteList.indexOf(to.path) !== -1) {
        next();
      } else {
        next("/login"); // 否则全部重定向到登录页
        NProgress.done();
      }
    }

  }
});

router.afterEach(() => {
  NProgress.done(); // 结束Progress
});

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});



// WEBPACK FOOTER //
// ./src/permission.js